import { render, staticRenderFns } from "./CollectCourse.vue?vue&type=template&id=30e5341f&scoped=true"
import script from "./CollectCourse.vue?vue&type=script&lang=js"
export * from "./CollectCourse.vue?vue&type=script&lang=js"
import style0 from "./CollectCourse.vue?vue&type=style&index=0&id=30e5341f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5341f",
  null
  
)

export default component.exports